<span
  *ngFor="let item of items; let i = index"
  [class]="'ad-skeleton-loader item' + (i + 1)"
  [style.width.%]="widthPercentage"
  [ngClass]="{
    'ad-skeleton-loader-circle': appearance === 'circle'
  }"
  [ngStyle]="styles"
>
</span>
